import { render, staticRenderFns } from "./SetExpertFlagModal.vue?vue&type=template&id=3a3b79f4&scoped=true"
import script from "./SetExpertFlagModal.vue?vue&type=script&lang=js"
export * from "./SetExpertFlagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3b79f4",
  null
  
)

export default component.exports